export const version = "1.0.2-daily-20260114-0";
export const channel = "daily";
export const gitcommit = "f990ec1c2";
